import { render, staticRenderFns } from "./ProductTemplateBuilderItemAdd.vue?vue&type=template&id=69ab3760&scoped=true"
import script from "./ProductTemplateBuilderItemAdd.vue?vue&type=script&lang=js"
export * from "./ProductTemplateBuilderItemAdd.vue?vue&type=script&lang=js"
import style0 from "./ProductTemplateBuilderItemAdd.vue?vue&type=style&index=0&id=69ab3760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ab3760",
  null
  
)

export default component.exports